import { render, staticRenderFns } from "./TicketDetailsLeftSidebar.vue?vue&type=template&id=7cf84f66"
import script from "./TicketDetailsLeftSidebar.vue?vue&type=script&lang=js"
export * from "./TicketDetailsLeftSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports